import { c as _c } from "react/compiler-runtime";
import { Tooltip } from 'platform/components';
import { HStack } from 'platform/foundation-tw';
import { Link } from 'react-router-dom';
import { isNil } from 'ramda';
import { CellRendererProps } from '../../types/CellRendererProps';
import { TooltipGetter } from '../../types/TooltipGetter';
import { getCellClassName } from '../../utils/getCellClassName';
import { getTooltipProps } from '../../utils/getTooltipProps';
type LinkValue = {
  label: string;
  url: string;
} | null;
type LinkCellRendererProps = CellRendererProps<LinkValue> & {
  getTooltipProps?: TooltipGetter;
};
const stopPropagationOnRef = (ref: HTMLAnchorElement | null) => {
  if (!ref) {
    return;
  }
  ref.onclick = event => event.stopPropagation();
};
export function LinkCellRenderer(props) {
  const $ = _c(14);
  let t0;
  if ($[0] !== props.column) {
    t0 = getCellClassName(props.column);
    $[0] = props.column;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const className = t0;
  let t1;
  if ($[2] !== props.getTooltipProps || $[3] !== props.row) {
    t1 = getTooltipProps(props.row, {}, props.getTooltipProps);
    $[2] = props.getTooltipProps;
    $[3] = props.row;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const tooltipProps = t1;
  if (isNil(props.value)) {
    return null;
  }
  let t2;
  if ($[5] !== props.value.label || $[6] !== props.value.url) {
    t2 = <HStack><Link to={props.value.url} ref={stopPropagationOnRef}>{props.value.label}</Link></HStack>;
    $[5] = props.value.label;
    $[6] = props.value.url;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== className || $[9] !== t2) {
    t3 = <div className={className}>{t2}</div>;
    $[8] = className;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t3 || $[12] !== tooltipProps) {
    t4 = <Tooltip {...tooltipProps}>{t3}</Tooltip>;
    $[11] = t3;
    $[12] = tooltipProps;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}